import { Loader } from "@googlemaps/js-api-loader";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import autoComplete from "@tarekraafat/autocomplete.js";
import { bbox, buffer, circle } from "@turf/turf";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";
const InfiniteScroll = require('infinite-scroll');

let params = getQueryParams();
let mapboxContainer = "mapbox_map";
let $map_holder = document.getElementById(mapboxContainer);
let form = document.getElementById("dealer-search-form");
let $geocode = form.querySelector('input[name="location"]');
let $lat = form.querySelector('input[name="lat"]');
let $lng = form.querySelector('input[name="lng"]');

let $geocodeValue = getFromParams("location");
if($geocodeValue != '') {
    $geocode.value = $geocodeValue;
}

let $latValue = getFromParams("lat");
if($latValue != '') {
    $lat.value = $latValue;
}

let $lngValue = getFromParams("lng");
if($lngValue != '') {
    $lng.value = $lngValue;
}

let $dealer = getFromParams("dealer");
if($dealer != '') {
    form.querySelector('input[name="dealer"]').value = $dealer;
}

let $category = getFromParams("category");
if($category != '' && form.querySelector('select[name="category"]').querySelector("option[value='" + $category + "']")) {
    form.querySelector('select[name="category"]').querySelector("option[value='" + $category + "']").selected = true;
}

let dragSearch = true;
let forceSearch = true;
let manualMapMovement = false;

const zoomLimit = {
    zoom: 1,
    min: 1,
    max: 20,
    markerZoom: 15,
};

export const instance = mapboxgl
export const $map = $map_holder
export let map = {}
export let markers = {}

const google = (window.google = window.google ? window.google : {})
const firstLimit = 100;
const genLimit = 100;
const ajaxWrapper = document.querySelector(".ajax-items");
const mobileMapOpenBtn = document.querySelector(".map-click");
const markerFilter = ["in", "id"];
const colorRed = "#aa192d";

let polygen = false;
let autocomplete;
let hitEntryOnLocation = false;
let first = true;
let infScroll;
let radius = false;
let regBound = false;

// let defaultLat = 37.1255861;
// let defaultLng = -106.251174;

let defaultLat = 21.289376734147936;
let defaultLng = -26.780927233808683;
let autoCompleteFieldId = "dealerAutoComplete";

window.addEventListener("load", (event) => {
    if (!$lat.value) {
        $lat.value = defaultLat;
    }

    if (!$lng.value) {
        $lng.value = defaultLng;
    }

    mapboxgl.accessToken = $map_holder.dataset.mapbox;
    // In case if we need to make map right to left.
    /*if (document.documentElement.lang == 'he') {
        // Set RTL plugin so Hebrew text isn't reversed
        mapboxgl.setRTLTextPlugin(
            'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
            null,
            true // Lazy load the plugin
        );
    }*/

    map = new mapboxgl.Map({
        container: mapboxContainer,
        style: "mapbox://styles/mapbox/light-v10",
        center: [$lngValue != '' ? $lngValue : defaultLng, $latValue != '' ? $latValue : defaultLat],
        // maxBounds: [
        //     [33.75, 29.375],
        //     [36.125, 33.5],
        // ],
        zoom: zoomLimit.zoom,
        minZoom: zoomLimit.min,
        maxZoom: zoomLimit.max,
        scrollZoom: true,
    }).addControl(new mapboxgl.NavigationControl(), "top-right");

    map.on("load", () => {
        let labels = ['country-label', 'state-label',
            'settlement-label', 'settlement-subdivision-label',
            'airport-label', 'poi-label', 'water-point-label',
            'water-line-label', 'natural-point-label',
            'natural-line-label', 'waterway-label', 'road-label'];

        labels.forEach(label => {
            map.setLayoutProperty(label, 'text-field', ['get', `name_${document.documentElement.lang}`]);
        });

        let lat, lng, location;
        params.forEach(function (val, index) {
            if (val.name == "lat") lat = val.value ? val.value : $lat.value;
            if (val.name == "lng") lng = val.value ? val.value : $lng.value;
            if (val.name == "location") location = val.value ? val.value : $geocode.value;
        });

        if (lat && lng && location) {
            prepareQuery({
                location: location,
                lat: lat,
                lng: lng,
            })
        } else if (lat && lng) {
            addToParams("lat", lat);
            addToParams("lng", lng);

            first = true;
            performMagic(params);
        } else if (location) {
            findLatLngFromAddressAndSearchAgain(location);
        } else {
            getLocation();
        }
    }).on("click", "markers", e => {
        const marker = e.features[0]
        let data = marker.properties;
        params = getQueryParams();
        let paramLocation = getFromParams("location");
        let html = createMarkerPopup(data, paramLocation);
        const popup = new instance.Popup()
            .setLngLat(marker.geometry.coordinates.slice())
            .setHTML(html)
            .setMaxWidth("250px")
            .addTo(map)

    }).on("dragend", e => {
        if (!dragSearch) {
            return false;
        }

        // console.log('FS3')
        forceSearch = false;
        formSubmit();
    }).on('zoomend', e => {

        if(manualMapMovement) {
            manualMapMovement = false;
            return false;
        }

        if (!dragSearch && map.getZoom() > 7) {
            return false;
        }

        // console.log('FS4')
        forceSearch = false;
        dragSearch = true;
        hitEntryOnLocation = true;
        formSubmit();
    }).on("mouseenter", "markers", function (e) {
        // document.querySelector(".js-dealer--card[data-key='" + e.features[0].properties.id + "']").scrollIntoView({ behavior: "smooth" });
        map.getCanvas().style.cursor = "pointer"
    })
        .on("mouseleave", "markers", function () {
            map.getCanvas().style.cursor = ""
        });

    geoCodeAutoComplete();
    setupAutocomplete();

    window.addEventListener('resize', function (event) {
        setTimeout(function () {
            mapResize();
        }, 50);
    }, true);
});

function setupAutocomplete() {
    // The autoComplete.js Engine instance creator
    const autoCompleteJS = new autoComplete({
        data: {
            src: async () => {
                try {
                    // Loading placeholder text
                    // document.getElementById(autoCompleteFieldId).setAttribute("placeholder", "Loading...");
                    // Fetch External Data Source
                    const data = await fetch("/api", {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: "application/json",
                            Authorization: `Bearer ${process.env.DEALER_LOCATOR_GQL_TOKEN}`
                        },
                        cache: "force-cache",
                        body: JSON.stringify({
                            query: `query DealerLocator($section: [String]) {
                                entries(section: $section, orderBy: "title asc") {
                                  title
                                }
                              }`,
                            variables: {
                                section: ["dealerLocator", "manualDealers"]
                            }
                        })
                    })
                    .then(response => response.json())

                    // Post Loading placeholder text
                    // document.getElementById(autoCompleteFieldId).setAttribute("placeholder", autoCompleteJS.placeHolder);

                    return data.data.entries;
                } catch (error) {
                    return error;
                }
            },
            keys: ["title"],
            cache: true,
            filter: (list) => {
                // Filter duplicates
                // incase of multiple data keys usage
                const filteredResults = Array.from(
                    new Set(list.map((value) => value.match))
                ).map((title) => {
                    return list.find((value) => value.match === title);
                });

                return filteredResults;
            }
        },
        selector: `#${autoCompleteFieldId}`,
        submit: true,
        placeHolder: translate("Dealer"),
        searchEngine: "loose",
        resultsList: {
            element: (list, data) => {
                list.setAttribute('aria-label', autoCompleteJS.placeHolder);

                /* const info = document.createElement("p");
                if (data.results.length > 0) {
                    info.innerHTML = `Displaying <strong>${data.results.length}</strong> out of <strong>${data.matches.length}</strong> results`;
                } else {
                    info.innerHTML = `Found <strong>${data.matches.length}</strong> matching results for <strong>"${data.query}"</strong>`;
                }
                info.classList.add("px-1", "text-sm", "text-primary-500", "italic");
                list.prepend(info); */
                if (data.results.length == 0) {
                    const info = document.createElement("p");
                    info.innerHTML = `Found <strong>${data.matches.length}</strong> matching results for <strong>"${data.query}"</strong>`;
                    info.classList.add("px-1", "text-sm", "text-primary-500");
                    list.prepend(info);
                }
            },
            noResults: true,
            maxResults: 15,
            tabSelect: true
        },
        resultItem: {
            element: (item, data) => {
                // Modify Results Item Style
                item.classList.add("flex", "justify-between");
                // Modify Results Item Content
                item.innerHTML = `<span class="overflow-ellipsis overflow-hidden whitespace-nowrap">${data.match}</span>`;
            },
            highlight: true
        },
        events: {
            input: {
                focus: () => {
                    if (autoCompleteJS.input.value.length) {
                        forceSearch = true;
                        autoCompleteJS.start();
                    }
                }
            }
        }
    });

    const unlabelledListbox = document.querySelector('ul[role="listbox"]:not([aria-label])');
    if (unlabelledListbox) {
        unlabelledListbox.setAttribute('aria-label', autoCompleteJS.placeHolder);
    }

    autoCompleteJS.input.addEventListener("selection", function (event) {
        const feedback = event.detail;
        autoCompleteJS.input.blur();
        // Prepare User's Selected Value
        const selection = feedback.selection.value[feedback.selection.key];
        // Replace Input value with the selected value
        autoCompleteJS.input.value = selection;

        forceSearch = true;
        // console.log('FS1')
        formSubmit();
    });
}

mobileMapOpenBtn.addEventListener('click', function (event) {
    event.preventDefault();
    setTimeout(function () {
        mapResize();
    }, 150);
}, true);

form.addEventListener("submit", function (event) {
    event.preventDefault();
    forceSearch = true;
    // console.log('FS2')
    return formSubmit();
});

function getLocation() {
    if ('permissions' in navigator) {
        navigator.permissions.query({ name: 'geolocation' })
            .then(function (permissionStatus) {
                if (permissionStatus.state === 'granted') {
                    // Geolocation permission granted
                    // console.log('Geolocation permission granted');
                    return navigator.geolocation.getCurrentPosition(showPosition);
                } else if (permissionStatus.state === 'prompt') {
                    // Geolocation permission prompt (user will be asked to grant or deny)
                    // console.log('Geolocation permission prompt');
                    navigator.geolocation.getCurrentPosition(showPosition);
                    // getMapCenterAndStartSearch();
                } else if (permissionStatus.state === 'denied') {
                    // Geolocation permission denied
                    // console.log('Geolocation permission denied');
                    // getMapCenterAndStartSearch();
                }
            })
            .catch(function (error) {
                console.error('Error occurred while checking geolocation permission:', error);
                // getMapCenterAndStartSearch();
            });
    } else {
        // getMapCenterAndStartSearch();
        // console.log('Geolocation permission API is not supported');
    }
}

function showPosition(position) {
    // x.innerHTML = "Latitude: " + position.coords.latitude +
    // "<br>Longitude: " + position.coords.longitude;
    submitStartingForm(position.coords.latitude, position.coords.longitude);
}

function getMapCenterAndStartSearch() {
    let center = map.getCenter();

    addToParams("lat", center.lat);
    addToParams("lng", center.lng);

    first = true;
    performMagic(params);
}

function submitStartingForm(lat, lng) {
    prepareQuery({
        location: null,
        lat: lat,
        lng: lng,
    })
    // formSubmit();
}

function formSubmit() {
    dragSearch = true;
    locationErrorHandling(true);

    if ($geocode === document.activeElement && !hitEntryOnLocation) {
        return false;
    }

    /*if($geocode.value == "") {
        // removeLayerIfExists(map, "locationFill");
        // removeLayerIfExists(map, "locationOutline");
        // removeSourceIfExists(map, "location");
        hitEntryOnLocation = true;
    }*/

    if ($lat.value == '' || $lng.value == '') {

        if ($geocode.value != "") {
            findLatLngFromAddressAndSearchAgain($geocode.value);
            return false;
        } else {
            return getMapCenterAndStartSearch();
        }
    }

    hitEntryOnLocation = false;

    let formData = new FormData(form);
    let params = [];
    formData.forEach(function (value, name) {
        params.push({ name: name, value: value });
    });

    first = true;
    performMagic(params);
    return false;
}

function performMagic(params) {
    if (first) {
        startFreshMarkers();
        if (infScroll) infScroll.destroy();

        let scrollToTopPixel = 0;
        if (window.innerWidth > 767) {
            scrollToTopPixel = 72;
        }

        if (window.innerWidth > 1280) {
            scrollToTopPixel = 76;
        }

        if (scrollToTopPixel > 0) {
            window.scrollTo(0, scrollToTopPixel);
        }
    }

    showLoader();

    var queryString = new URLSearchParams();
    let tempParam = [];
    params.forEach(function (data) {
        if (data.value) {
            queryString.append(data.name, data.value);
            tempParam.push({ name: data.name, value: data.value });
        }
    });

    queryString = queryString.toString();
    let url = window.location.pathname + (params ? '?' + queryString : '');
    window.history.pushState({ path: url }, '', url);

    document.querySelectorAll(".lang-option").forEach(function (option) {
        option.setAttribute("href", option.dataset.url + (params ? '?' + queryString : ''));
    });

    // let bounds = regBound ? regBound : map.getBounds().toArray();
    let bounds = map.getBounds().toArray();

    tempParam.push({ name: 'bounds[x]', value: bounds[0][0] + ',' + bounds[0][1] });
    tempParam.push({ name: 'bounds[y]', value: bounds[1][0] + ',' + bounds[1][1] });
    tempParam.push({ name: 'limit', value: (first ? firstLimit : genLimit) });
    tempParam.push({ name: 'reg-limit', value: genLimit });
    tempParam.push({ name: 'force', value: forceSearch });

    var found = false;
    infScroll = new InfiniteScroll(ajaxWrapper, {
        path: function () {
            let page = this.pageIndex;
            let queryString = new URLSearchParams();
            tempParam.forEach(function (data) {
                queryString.append(data.name, data.value);
            });
            queryString = queryString.toString();

            return form.getAttribute('action') + '?' + queryString + "&page=" + page;
        },
        fetchOptions: {
            cache: 'force-cache',
        },
        responseBody: 'json',
        status: '.page-load-status',
        history: false,
    });

    // load initial page
    infScroll.loadNextPage();

    setupInfiniteLoad();
}

function setupInfiniteLoad() {
    infScroll.on('load', function (body) {
        // console.log(body);
        let cards = "";
        params = getQueryParams();
        let paramLocation = getFromParams("location");
        // console.log(paramLocation)
        body.results.forEach(function (dealer, index) {
            if (index < genLimit) {
                cards += createDealerCard(dealer, paramLocation);
            }

            let marker = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [dealer.longitude, dealer.latitude]
                },
                properties: dealer
            };

            markers.features.push(marker);
            markerFilter.push(marker.properties.id);
        });

        if (first && cards == "") {
            cards = `<div class="w-full p-4">
                <p class="mt-6 text-base text-center">
                    ` + translate("No dealers found for your search term.") + `
                </p>
            </div>`;
        }

        if (first) {
            if (map.getSource("markers")) {
                map.removeLayer("markers");
                map.removeLayer("markers-highlighted");
                map.removeSource("markers");
            }

            map.addSource("markers", {
                type: "geojson",
                data: markers,
            });

            addMarkerLayer("markers", {
                "circle-color": colorRed,
                "circle-radius": 7.5,
                "circle-stroke-width": 1,
                "circle-stroke-opacity": 0.4,
            });

            addMarkerLayer("markers-highlighted", {
                "circle-color": colorRed,
                "circle-radius": 12,
                "circle-stroke-color": colorRed,
                "circle-stroke-width": 7,
                "circle-stroke-opacity": 0.6,
            });

        } else {
            map.getSource("markers").setData(markers)
        }

        // Display only the dealer markers that are within the dealer list
        map.setFilter("markers", markerFilter);

        if (first) {
            // let catInput = form.querySelector('select[name="category"]');
            let catInput = getFromParams("category");;
            let message = catInput.value ? translate(catInput.querySelector("option[value='" + catInput.value + "']").innerText + " dealers") : translate("Dealers");
            message += ($geocode.value ? " " + translate("in") + " " + $geocode.value : "");
            document.querySelector('.search-heading').innerHTML = message;

            ajaxWrapper.innerHTML = cards;

            if (forceSearch && body.results.length) {
                let bounds = bbox(markers);
                map.fitBounds(bounds, {
                    padding: 50,
                    duration: 200,
                    maxZoom: 15
                });
                manualMapMovement = true
            }

        } else {
            if (ajaxWrapper.querySelector('a.next-page')) {
                ajaxWrapper.querySelector('a.next-page').remove();
            }

            ajaxWrapper.innerHTML += cards;
        }

        operationsAfterDataInjected();
        hideLoader();

        if (!body.results.length || body.results.length < genLimit) {
            infScroll.destroy();
            document.querySelector("footer").classList.remove("hidden");
        } else {
            document.querySelector("footer").classList.add("hidden");
        }

        first = false;
    });

    infScroll.on( 'error', function( error, path, response ) {
        // console.log(error)
        ajaxWrapper.innerHTML = "";
        hideLoader();
    })

}

function createDealerCard(dealer, location = '') {
    let card = `<div class="js-dealer--card relative lg:flex flex-wrap items-center shadow-lg p-3 md:p-5 mb-4 hover:bg-white bg-concrete-500 hover:translate-x-3 transition-all" data-key="${dealer.id}">
        <div class="md:flex-1">
            <div class="mb-4">
                <h3 class="text-xl font-bold">${dealer.title}</h3>
                <p>${dealer.addressLine2 ? dealer.addressLine2 + ', ' : ''}${dealer.city ? dealer.city + ', ' : ''}${dealer.provinceStateCode ? (dealer.provinceStateCode + ', ') : ''}${dealer.postalZipCode ? dealer.postalZipCode + ', ' : ''}${dealer.countryCode ? dealer.countryCode : ''}</p>
            </div>`;

    if (dealer.phone) {
        card += `<div class="mb-1">
                    <a href="tel:` + cleanPhoneNumber(dealer.phone) + `" rel="noopener" class="inline-flex items-center hover:text-primary-500">
                        <svg class="w-4 h-4 mr-2" fill="currentColor">
                            <use xlink:href="#ico--phone"></use>
                        </svg>
                        <span>${dealer.phone}</span>
                    </a>
                </div>`;
    }

    if (dealer.web) {
        card += `<div>
                    <a href="` + addHttpsToUrl(dealer.web) + `" target="_blank" rel="noopener" class="inline-flex items-center hover:text-primary-500">
                        <svg class="w-4 h-4 mr-2" fill="currentColor">
                            <use xlink:href="#ico--web"></use>
                        </svg>
                        <span>` + dealer.web + `</span>
                    </a>
                </div>`;
    }

    card += `</div>
        <div class="pt-5 xl:px-5">
            <div class="flex flex-wrap items-center">
                <a href="https://www.macdon.com/request-a-demo?dealer=${dealer.addressBookNumber}" target="_blank" rel="noopener" class="bg-primary-500 hover:bg-primary-400 transition-all text-white uppercase text-lg inline-block px-10 py-2">${translate("Request Demo")}</a>

                <a href="#" class="js-open-marker md:absolute md:top-0 md:right-0 md:mt-2 ml-4 md:ml-0 hover:text-primary-500 text-sm" aria-label="${translate('Open this location in map.')}" data-key="${dealer.id}">
                    <svg class="w-7 h-7 mr-3" fill="currentColor">
                        <use xlink:href="#ico--map"></use>
                    </svg>
                </a>
            </div>
            ` +
            (location != '' ? `<span class="block mt-2 text-primary-500 text-sm">${Number(dealer.distance).toFixed(2)} ${'km away'}</span>` : '')
            + `
        </div>
    </div>`;
    return card;
}

function createMarkerPopup(dealer, location = '') {
    // console.log(location)
    let card = `
        <div class="p-4">
            <div class="mb-4">
                <h3 class="text-base font-bold">${dealer.title}</h3>
                <p class="text-sm">${dealer.addressLine2 ? dealer.addressLine2 + ', ' : ''}${dealer.city ? dealer.city + ', ' : ''}${dealer.provinceStateCode ? (dealer.provinceStateCode + ', ') : ''}${dealer.postalZipCode ? dealer.postalZipCode + ', ' : ''}${dealer.countryCode ? dealer.countryCode : ''}</p>
            </div>`;

    if (dealer.phone || dealer.web) {
        card += `<div class="mb-4">`;
    }

    if (dealer.phone) {
        card += `
                <div class="mb-1">
                    <a href="tel:` + cleanPhoneNumber(dealer.phone) + `" rel="noopener" class="text-sm inline-flex items-center hover:text-primary-500">
                        <svg class="w-4 h-4 mr-2" fill="currentColor">
                            <use xlink:href="#ico--phone"></use>
                        </svg>
                        <span>${dealer.phone}</span>
                    </a>
                </div>`;
    }

    if (dealer.web) {
        card += `
                <div>
                    <a href="` + addHttpsToUrl(dealer.web) + `" target="_blank" rel="noopener" class="text-sm inline-flex items-center hover:text-primary-500">
                        <svg class="w-4 h-4 mr-2" fill="currentColor">
                            <use xlink:href="#ico--web"></use>
                        </svg>
                        <span>` + dealer.web + `</span>
                    </a>
                </div>`;
    }

    if (dealer.phone || dealer.web) {
        card += `</div>`;
    }

    card += `
        <div class="">
            <a href="https://www.macdon.com/request-a-demo?dealer=${dealer.addressBookNumber}" target="_blank" rel="noopener" class="text-sm bg-primary-500 hover:bg-primary-400 transition-all text-white uppercase inline-block px-4 py-2">${translate('Request Demo')}</a>
            ` +
            (location != '' ? `<span class="block mt-2 text-primary-500 text-xs">${Number(dealer.distance).toFixed(2)} ${translate('km away')}</span>` : '')
            + `
            </div>
    </div>`;
    return card;
}

function operationsAfterDataInjected() {
    // Get all elements with the class "js-dealer--card"
    let cards = document.querySelectorAll('.js-dealer--card');

    // Add event listeners to each card
    cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
            let key = this.dataset.key;
            map.setFilter('markers-highlighted', ['in', 'id', Number(key)]);
        });

        card.addEventListener('mouseleave', function () {
            map.setFilter('markers-highlighted', ['in', 'id', '']);
        });
    });

    // Get all elements with the class "js-open-marker"
    let markerCards = document.querySelectorAll('.js-open-marker');

    // Add event listeners to each card
    markerCards.forEach(function (card) {
        card.addEventListener('click', function (event) {
            event.preventDefault();

            let key = this.dataset.key;
            markers.features.forEach(function (value, index) {
                if (value.properties.id == key) {
                    dragSearch = false;

                    if (window.innerWidth > 767) {
                        map.flyTo({
                            center: [value.properties.longitude, value.properties.latitude],
                            zoom: zoomLimit.markerZoom,
                            essential: true,
                            duration: 2000
                        });
                    } else {
                        mobileMapOpenBtn.click();

                        setTimeout(function () {
                            map.flyTo({
                                center: [value.properties.longitude, value.properties.latitude],
                                zoom: zoomLimit.markerZoom,
                                essential: true,
                                duration: 2000
                            });
                        }, 200);
                    }


                    return true;
                }
            })
        });
    });
}

function geoCodeAutoComplete() {
    new Loader({
        apiKey: $map_holder.dataset.gmap,
        libraries: ["places"],
        language: document.documentElement.lang,
    })
        .load().then(() => {
            autocomplete = new google.maps.places.Autocomplete($geocode, {
                types: ["geocode"],
                fields: [
                    'formatted_address',
                    'geometry.location',
                ],
                // componentRestrictions: {
                //     country: ["us"],
                // },
            })

            autocomplete.addListener("place_changed", setLocation)
        });
}

function setLocation() {
    const place = autocomplete.getPlace();
    let fieldId = $geocode.getAttribute('id');

    if (typeof (place.geometry) === 'undefined') {
        if (place.name != '') {
            hitEntryOnLocation = false;
            findLatLngFromAddressAndSearchAgain(place.name);
        } else {
            hitEntryOnLocation = true;
        }

        return;
    }

    hitEntryOnLocation = false;
    // $geocode.value = place.formatted_address.replace(", Israel", "")
    let lat = place.geometry.location.lat();
    let lng = place.geometry.location.lng();
    let location = $geocode.value;

    $lat.value = lat;
    $lng.value = lng;

    prepareQuery({
        location: location,
        lat: lat,
        lng: lng,
    });

    /*map.setZoom(12);
    map.setCenter([lng, lat]);*/
}

function locationErrorHandling(removeOnly = false) {
    /* let el = $geocode.parentElement.querySelector("div.error-inner");
    console.log($geocode)
    if (el) {
        el.remove();
    } */

    if (!removeOnly) {
        /* let div = document.createElement("div");
        div.classList.add("error-inner", "text-red-500", "text-sm");
        div.append();

        $geocode.parentElement.append(div); */

        dispatchError(translate("Error Submiting form"), translate("Search location you tried seems to be invalid."));
    }
}

function getQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    let params = [];
    let entries = urlParams.entries();
    for (const entry of entries) {
        params.push({ name: entry[0], value: entry[1] });
    }

    return params;
}

function findLatLngFromAddressAndSearchAgain(address) {
    return fetch("https://maps.googleapis.com/maps/api/geocode/json?" + new URLSearchParams({
        key: $map_holder.dataset.gmapgeocoding,
        language: document.documentElement.lang,
        // components: 'country:us',
        address: address
    }), {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
        cache: "force-cache"
    })
        .then(response => response.json())
        .then(data => {
            if (data.status == "OK") {
                let geo = data.results[0].geometry;
                let newLocation = data.results[0].formatted_address;

                $lat.value = geo.location.lat;
                $lng.value = geo.location.lng;

                prepareQuery({
                    location: newLocation,
                    lat: geo.location.lat,
                    lng: geo.location.lng,
                });
            } else {
                locationErrorHandling();
                $geocode.value = "";
            }
        });
}

function prepareQuery(meta) {
    $geocode.value = meta.location ?? null;
    $lat.value = meta.lat ?? null;
    $lng.value = meta.lng ?? null;

    regBound = false;
    radius = false;

    removeLayerIfExists(map, "locationFill");
    removeLayerIfExists(map, "locationOutline");
    removeSourceIfExists(map, "location");

    Promise.all([getBoundaries(meta.location)]).then(boundaryData => {
        if (map.getSource("location")) {
            drawBoundaries();

            regBound = boundaryData[0];
            map.fitBounds(regBound, {
                padding: 50,
                duration: 200
            });
        } else {
            var center = [meta.lng, meta.lat];
            radius = 2.5;
            var options = { steps: 55, units: 'kilometers' };
            var c = circle(center, radius, options);

            var b = bbox(c);
            regBound = [
                [
                    b[0],
                    b[1]
                ],
                [
                    b[2],
                    b[3]
                ]
            ];

            removeLayerIfExists(map, "locationFill");
            removeLayerIfExists(map, "locationOutline");
            removeSourceIfExists(map, "location");
            map.addSource("location", {
                type: "geojson",
                data: c.geometry,
            })
            drawBoundaries();

            map.fitBounds(regBound, {
                padding: 50,
                duration: 200
            });

        }

        return regBound;
    }).then(boundaryData => {
        /*hitEntryOnLocation = true;
        formSubmit();*/
    });
}

function getBoundaries(location) {
    // set default location for openstreetmap endpoint
    // if the location is set get coordinates
    polygen = false;
    if (location) {

        return fetch("https://nominatim.openstreetmap.org/search.php?q=" + location + "&polygon_geojson=1&format=json", {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
            cache: "force-cache"
        })
            .then(response => response.json())
            .then(data => {
                if (data.length == 0) return false;

                // filter the data to get only the polygon coordinates
                let localizedData = data.filter(
                    val =>
                        (data.length > 1 ? val.geojson.type.includes("Polygon") && val.class != "tourism" : true)
                )

                if (localizedData.length === 0) {
                    localizedData = data.filter(
                        val =>
                            (data.length > 1 ? val.geojson.type.includes("Polygon") : true)
                    )
                }

                if (localizedData.length) {
                    let d;
                    data = localizedData;
                    const boundaryData = data.find(x => x.class == 'boundary');

                    if (boundaryData) {
                        data = getPolygon(boundaryData)
                        d = getBoundingBox3(data);
                    } else {
                        data = getPolygon(data[0]);
                        d = getBoundingBox3(data);
                    }

                    polygen = data;

                    removeLayerIfExists(map, "locationFill");
                    removeLayerIfExists(map, "locationOutline");
                    removeSourceIfExists(map, "location");
                    map.addSource("location", {
                        type: "geojson",
                        data: data.geometry,
                    });

                    if (location == "USA" || location == "United States") {
                        return [[-124.736342, 49.382808], [-66.945392, 24.521208]];
                    } else if (location == "Canada") {
                        return [[-127.04488959947128, 46.84335005883247], [-93.56611457505713, 67.56632192699053]];
                    } else if (location == "Australia") {
                        return [[113.1833866242153, -43.18948268415735], [155.58306008612902, -8.396740704298026]];
                    } else if (location == "New Zealand") {
                        return [[167.56687045493499, -47.123778189733535], [176.25112313112277, -40.23886012876884]];
                    }
                    return d;
                } else {
                    return false;
                }
            });
    } else {
        return false;
    }
}

function drawBoundaries() {
    // Add a new layer to visualize the polygon.
    map.addLayer({
        id: "locationFill",
        type: "fill",
        source: "location", // reference the data source
        layout: {},
        paint: {
            "fill-color": "#0080ff", // blue color fill
            "fill-opacity": 0.1,
        },
    })
    // Add a black outline around the polygon.
    map.addLayer({
        id: "locationOutline",
        type: "line",
        source: "location",
        layout: {},
        paint: {
            "line-color": "#000",
            "line-width": 2,
        },
    })
}

function getPolygon(data) {
    let value = {
        type: "Feature",
        properties: {},
        geometry: { ...data.geojson },
        lat: data.lat,
        lng: data.lon
    }

    if ("LineString" === data.geojson.type) {
        value = buffer(value, 1)
    } else if ("Point" === data.geojson.type) {
        value = circle(value, 1)
    }

    return value
}

function addMarkerLayer(layerId, layerPaint) {
    map.addLayer({
        id: layerId,
        source: "markers",
        type: "circle",
        paint: layerPaint,
        filter: ["in", "id", ""],
    });
}

function getBoundingBox3(data) {
    let d = bbox(data);
    return [
        [
            d[0],
            d[1]
        ],
        [
            d[2],
            d[3]
        ]
    ];
}

function startFreshMarkers() {
    markers = {
        type: 'FeatureCollection',
        features: []
    };
}

function removeLayerIfExists(map, layer) {
    if (map.getLayer(layer)) {
        map.removeLayer(layer)
    }
}

function removeSourceIfExists(map, source) {
    if (map.getSource(source)) {
        map.removeSource(source)
    }
}

function addHttpsToUrl(url) {
    if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//')) {
        url = 'https://' + url;
    }
    return url;
}

function cleanPhoneNumber(phoneNumber) {
    // Remove parentheses, dashes, and spaces
    var cleanedNumber = phoneNumber.replace(/[\(\)\-\s]/g, '');

    return cleanedNumber;
}

function showLoader() {
    document.querySelectorAll(".ajax--loading").forEach(function (item) {
        item.classList.remove("hidden")
    });
}

function hideLoader() {
    document.querySelectorAll(".ajax--loading").forEach(function (item) {
        item.classList.add("hidden")
    });
}

function addToParams(key, newVal) {
    let foundParam = false;
    params.forEach(function (val, index) {
        if (val.name == key) {
            params[index].value = newVal;
            foundParam = true;
        }
    });

    if (!foundParam) {
        params.push({ name: key, value: newVal });
    }
}

function getFromParams(key) {
    let ret = '';
    params.forEach(function (val, index) {
        if (val.name == key) {
            ret = val.value;
        }
    });

    return ret;
}

function mapResize() {
    map.resize();
}

function translate(value) {
    return typeof (macdonOptions.translate[value]) !== 'undefined' ? macdonOptions.translate[value] : value;
}